module.exports = __webpack_public_path__ + "static/media/nepal_flag.428587aa.gif";